import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getToken } from "@/utils/auth";
import { updThreeData, addThreeData } from "@/api/loginConfig/getThreeList";
import util from '@/libs/util';
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow: function isShow(val) {
      this.dialogFormVisible = val;
    }
  },
  data: function data() {
    return {
      id: "",
      value1: "",
      value2: "",
      imageUrl: "",
      baseUrl: "",
      url: "",
      dialogImageUrl: "",
      file: "",
      upmsaseg: "",
      img: "",
      searchData: {
        login_name: "",
        login_mark: "",
        login_icon: ""
      },
      dialogFormVisible: false,
      fileList: [],
      isnum: 1,
      rules: {
        login_name: [{
          required: true,
          message: '请输入登录名称',
          trigger: 'blur'
        }],
        login_mark: [{
          required: true,
          message: '请输入登录标志',
          trigger: 'blur'
        }],
        login_icon: [{
          required: true,
          message: '请上传',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.url = process.env.VUE_APP_API;
  },
  methods: {
    init: function init(data, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isnum = type;

                if (type == 1) {
                  _this.searchData = {
                    login_name: "",
                    login_mark: "",
                    login_icon: ""
                  };
                  _this.fileList = [];
                }

                if (type == 2) {
                  _this.searchData.login_mark = data.login_mark;
                  _this.searchData.login_name = data.login_name;
                  _this.searchData.login_icon = data.login_icon;
                  _this.searchData.id = data.id;
                  setTimeout(function () {
                    _this.fileList = [{
                      url: data.login_icon,
                      status: "success"
                    }];
                  }, 300);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    BgUrl: function BgUrl(e) {
      this.fileList = e;
      this.searchData.login_icon = e.length ? e[0].url : '';
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this2.isnum == "1") {
            addThreeData(_this2.searchData).then(function (res) {
              if (res.status == 200) {
                _this2.$message({
                  message: '操作成功',
                  type: "success"
                });

                _this2.$emit("changeShow", false);
              }
            });
          }

          if (_this2.isnum == "2") {
            updThreeData(_this2.searchData).then(function (res) {
              if (res.status == 200) {
                _this2.$message({
                  message: '操作成功',
                  type: "success"
                });

                _this2.$emit("changeShow", false);
              }
            });
          }
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$emit("changeShow", false);
      this.dialogFormVisible = false;
      this.clearData();
    },
    clearData: function clearData() {
      this.fileList = [];
      this.searchData = {
        login_name: "",
        login_mark: "",
        login_icon: ""
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};